import React, { Component } from "react";
import { Elements } from "react-stripe-elements";
import StripePaymentForm from "./StripePaymentForm";

export class StripePaymentDetails extends Component {
  render() {
    const {
      donationFromProcessing,
      amount,
      currency,
      errorMsg,
      globalError,
      charityDetails,
      stripePaymentResponse,
      donationDetails,
      personalDetails,
    } = this.props;

    return (
      <Elements>
        <StripePaymentForm
          amount={amount}
          currency={currency}
          charityDetails={charityDetails}
          donationFromProcessing={donationFromProcessing}
          stripePaymentResponse={stripePaymentResponse}
          globalError={globalError}
          errorMsg={errorMsg}
          donationDetails={donationDetails}
          personalDetails={personalDetails}
        />
      </Elements>
    );
  }
}

export default StripePaymentDetails;
